import { useEffect, useState } from "react"
import { simpleGetter } from "../actions/common"
import { courseApi, lessonsApi } from "../api/api"
import { Course } from "../types"

export const useMyCourses = (triggerFetch?: number, postUpdate?: (list: any[]) => void): Course[] => {
    const [data, setData] = useState<Course[]>([])

    const fetchData = async () => {
        setData([])
        const response = await simpleGetter(courseApi.getMyCourses)
        if (response.list) {
            setData(response.list)
            if (postUpdate) {
                postUpdate(response.list)
            }
        }
    }

    useEffect(() => {
        fetchData()
    }, [triggerFetch])

    return data
}

export const useLesson = (lessonId: number, triggerFetch: number) => {
    const [data, setData] = useState({})

    const fetchData = async () => {
        setData([])
        const response = await simpleGetter(lessonsApi.getById, lessonId)
        if (response.item) {
            setData(response.item)
        }
    }

    useEffect(() => {
        if (lessonId) {
            fetchData()
        }
    }, [lessonId, triggerFetch])

    return data
}